import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { environment } from '../../environments/environment';

@Component({
  selector: 'app-site-footer',
  imports: [RouterLink],
  template: `
    <footer class="bg-navy-900 text-navy-200">
      <div class="container-page py-14">
        <div class="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div class="lg:col-span-2">
            <img
              src="images/fine-shine-logo.webp"
              [alt]="business.name"
              width="465"
              height="90"
              loading="lazy"
              class="h-12 w-auto"
            />
            <p class="mt-4 max-w-md text-sm leading-relaxed text-navy-300">
              Mobile car grooming and detailing across {{ business.city }}. We come to your home or
              office with everything needed to make your vehicle shine.
            </p>
          </div>

          <div>
            <h2 class="text-sm font-semibold tracking-wider text-white uppercase">Explore</h2>
            <ul class="mt-4 space-y-2.5 text-sm">
              @for (link of links; track link.path) {
                <li>
                  <a
                    [routerLink]="link.path"
                    class="text-navy-300 transition-colors hover:text-white"
                  >
                    {{ link.label }}
                  </a>
                </li>
              }
            </ul>
          </div>

          <div>
            <h2 class="text-sm font-semibold tracking-wider text-white uppercase">Get in touch</h2>
            <ul class="mt-4 space-y-2.5 text-sm">
              <li>
                <a
                  [href]="'tel:' + business.phone"
                  class="text-navy-300 transition-colors hover:text-white"
                >
                  {{ business.phoneDisplay }}
                </a>
              </li>
              <li>
                <a
                  [href]="'mailto:' + business.email"
                  class="break-all text-navy-300 transition-colors hover:text-white"
                >
                  {{ business.email }}
                </a>
              </li>
              <li class="text-navy-300">{{ business.region }}</li>
            </ul>

            <a routerLink="/bookings" class="btn-primary mt-5 !px-5 !py-2.5">Book a wash</a>
          </div>
        </div>

        <div
          class="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-navy-400 sm:flex-row sm:items-center sm:justify-between"
        >
          <p>&copy; {{ year }} {{ business.name }}. All rights reserved.</p>
          <p>{{ business.city }}, {{ business.region }}</p>
        </div>
      </div>
    </footer>
  `,
})
export class SiteFooterComponent {
  protected readonly business = environment.business;
  protected readonly year = new Date().getFullYear();

  protected readonly links = [
    { label: 'Home', path: '/' },
    { label: 'Services', path: '/our-services' },
    { label: 'Pricing', path: '/pricing-packages' },
    { label: 'Reviews', path: '/reviews' },
    { label: 'FAQs', path: '/faq' },
    { label: 'About', path: '/about-us' },
    { label: 'Contact', path: '/contact-us' },
  ];
}
